<template>
  <div>
    <header>
      <keyvet-header></keyvet-header>
    </header>

    <main class="container">
      <notifications class="serviceWorkerNotification"
                     width="400px"
                     group="serviceWorker"
                     :closeOnClick='false'>
      </notifications>

      <notifications class="main-notifications"
                     width="400px"
                     group="main"
                     :closeOnClick='true'>
      </notifications>

      <div v-if="alert.message" :class="`alert ${alert.type}`">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearAlert">
          <span aria-hidden="true">&times;</span>
        </button>
        {{alert.message}}
      </div>
      <router-view></router-view>
    </main>

    <footer class="container">
      <keyvet-footer></keyvet-footer>
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import KeyvetFooter from '../components/KeyvetFooter.vue'
import KeyvetHeader from '../components/KeyvetHeader.vue'

export default {
    name: 'app',
    computed: {
        ...mapState({
            alert: state => state.alert
        })
    },
    methods: {
        ...mapActions({
            clearAlert: 'alert/clear'
        })
    },
    watch: {
        $route (to, /* from */)
        {
          // clear alert on location change
          if (to.path != '/login' && !this.alert.persist) 
          {
              this.clearAlert();
          }
        }
    },
    components: {
      KeyvetFooter,
      KeyvetHeader,
    },
};
</script>

<style>

main {
  margin-top: 30px;
  margin-bottom: 50px;
  min-height: 710px;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 14px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}

.serviceWorkerNotification .vue-notification {
  border-radius: 0 0 0 5px;
  margin: 0;
  font-size: 18px;
}
</style>